export const steps = [
    {
        title: 'Connect Telegram',
        description: 'Free Credit',
        completed: false
    },
    {
        title: 'Learn the basics',
        description: 'Ready in no time',
        completed: false
    },
    {
        title: 'Get credit',
        description: 'Top up your account',
        completed: false
    },
    {
        title: 'All Done!',
        description: 'Onwards to growth!',
        completed: false
    }
]